import Swiper from 'swiper';

// Swiper Slider on Events
(function ($, Drupal) {
  Drupal.behaviors.eventsSlider = {
    attach: function (context, settings) {
      if ($('.js-events-slider .swiper-slide', context).length > 1) {
        const eventsSlider = new Swiper('.js-events-slider .swiper-container', {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          grabCursor: true,
          lazy: true,
          // If you use slidesPerView "auto" or slidesPerView > 1,
          // then you should also enable watchSlidesVisibility and Swiper will load images in currently visible slides
          watchSlidesProgress: true,
          watchSlidesVisibility: true,

          // Navigation arrows
          navigation: {
            nextEl: '.view-events .swiper-button-next',
            prevEl: '.view-events .swiper-button-prev',
          },
          breakpoints: {
            640: {
              slidesPerGroup: 1,
              // Free Mode
              // Only on mobile devices
              freeMode: true,
            }
          }
        });
      } else {
        $('.js-events-slider .swiper-navigation', context).addClass('hide');
      }
    }
  };
})(jQuery, Drupal);
